import {ColorsType} from '../../../../styles';
import {
  CheckboxSize,
  CheckboxState,
} from '../../Checkbox/Checkbox/checkbox_types.web';

type ChekboxIconProps = {
  id?: string;
  className?: string;
  size: CheckboxSize;
  colors: ColorsType;
  state: CheckboxState;
};

const pathDsBySize = {
  medium: [
    'M10.1543 18.1772L5.20068 12.9504L6.77592 11.2959L10.1543 14.8577L17.4954 7.11243L19.0707 8.77741L10.1543 18.1772Z',
  ],
  small: [
    'M7.15042 11.0548L4.80005 8.57481L5.54747 7.78981L7.15042 9.47981L10.6337 5.80481L11.3811 6.59481L7.15042 11.0548Z',
  ],
};

const checkrectBySize = {
  medium: {
    x: '-0.00012207',
    y: '-0.00012207',
    width: '24',
    height: '24',
    rx: '3',
  },
  small: {
    x: '1.59998',
    y: '1.59998',
    width: '12.8',
    height: '12.8',
    rx: '1.92',
  },
};

const disableContainerrectBySize = {
  medium: {
    x: '1.00012',
    y: '1.00012',
    width: '21.9998',
    height: '21.9998',
    rx: '1.99998',
  },
  small: {
    x: '2.09998',
    y: '2.09998',
    width: '11.8',
    height: '11.8',
    rx: '1.42',
  },
};

const disablerectBySize = {
  medium: {
    x: '3.99963',
    y: '3.99994',
    width: '16',
    height: '16',
    rx: '1',
  },
  small: {
    x: '3.73315',
    y: '3.73328',
    width: '8.53333',
    height: '8.53333',
    rx: '0.64',
  },
};

const ChekboxIcon = (props: ChekboxIconProps) => {
  const {id, className, size, colors, state} = props;
  const paths = pathDsBySize[size];
  const rectAttrs =
    state === 'active'
      ? checkrectBySize[size]
      : disableContainerrectBySize[size];
  const svgSize = size === 'medium' ? 24 : 16;
  return (
    <svg
      id={id}
      className={className}
      width={svgSize}
      height={svgSize}
      viewBox={`0 0 ${svgSize} ${svgSize}`}
      fill="none">
      <rect
        {...rectAttrs}
        stroke={
          state === 'error'
            ? colors.alert300
            : state !== 'active'
            ? state !== 'hover'
              ? colors.neutral400
              : colors.primary700
            : undefined
        }
        fill={state === 'active' ? colors.primary700 : colors.neutral100}
        strokeWidth="2"
      />
      {state === 'active' ? (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={paths[0]}
          fill={colors.neutral100}
        />
      ) : null}
      {state === 'disable' ? (
        <rect {...disablerectBySize[size]} fill={colors.neutral400} />
      ) : null}
    </svg>
  );
};

export default ChekboxIcon;
